/**
 * Angular imports.
 */
import { Component, OnInit, Input, OnDestroy } from '@angular/core';

/**
 * Service imports.
 */
import { OnboardingService } from '../../../dataservices/onboarding/onboarding.service';
import { GetService } from '../../../dataservices/get.service';
import { FunCollectionService } from '../../common-functions/fun-collection.service';
import { PostApiService } from '../../../dataservices/post-api.service';
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { MasterserviceService } from '../../../dataservices/master-service/masterservice.service';
import { MultiLangService } from '../../../dataservices/master-service/multi-lang.service';
import { JwtDecodeService } from '../../../dataservices/jwt-decode.service';
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * Country And Association Modal Component.
 */
@Component({
  selector: 'app-country-and-association-modal',
  templateUrl: './country-and-association-modal.component.html',
  styleUrls: ['./country-and-association-modal.component.scss']
})
export class CountryAndAssociationModalComponent implements OnInit, OnDestroy {

  @Input() callingfrom;
  public country_api_in_process = false;
  public user_country = [];
  public err_msg = '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public config: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public suggAssList: any;
  public selected_association = [];
  public showColor = false;
  public api_in_process = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public user_country_id: any;
  public displayObj = {
    isShow: false,
    display_section: '',
    data: [],
    errObj: []
  };

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();


  /**
   * Necessary instances.
   */
  constructor(
    public onboardingService: OnboardingService,
    private getApiSer: GetService,
    private postApiSer: PostApiService,
    private fcs: FunCollectionService,
    private dss: DataStorageService,
    private masterSer: MasterserviceService,
    public multiLangService: MultiLangService,
    private jwtSer: JwtDecodeService,
    public mls: NewLanguageService
  ) {
    if (this.dss.user_profile_data.profile.is_verified == 1) {
      this.onboardingService.ddl_data.disabled = true;
    }
  }

  /**
   * ngOnInit.
   */
  ngOnInit(): void {
    sessionStorage.removeItem('resub');
    this.user_country_id = this.dss.user_profile_data.profile.country_id;
    if (this.onboardingService.ddl_data.list_data.length == 0) {
      this.getCountryList();
    } else {
      this.user_country = [];
      this.suggAssList = this.dss.suggAssList;
      this.user_country = this.onboardingService.ddl_data.selected_data;
      this.showColor = (this.dss.selected_suggAssList.length > 0 && this.user_country.length > 0) ? true : false;
      this.getSuggestedAssociation();
    }
  }

  /**
   * get Country List.
   */
  getCountryList(): void {
    this.dss.selected_suggAssList = [];
    this.country_api_in_process = true;
    this.subscriptions.add(this.onboardingService.getCountryListV5().subscribe(resData => {
      this.country_api_in_process = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          this.onboardingService.ddl_data.list_data = [];
          for (let i = 0; i < data['data'].country_list.length; i++) {
            // tslint:disable-next-line: radix
            const temp = { id: parseInt(data['data'].country_list[i].id), itemName: data['data'].country_list[i].country, code: data['data'].country_list[i].country_code, image: 'assets/' + data['data'].country_list[i].flag_url, index: i };
            this.onboardingService.ddl_data.list_data.push(temp);
          }
          this.onboardingService.ddl_data.selected_data = [];
          const x = this.onboardingService.ddl_data.list_data.find(x => x.id == this.user_country_id);

          this.onboardingService.ddl_data.selected_data.push(x);
          this.user_country.push(x);
          this.country_api_in_process = false;
          if (this.dss.suggAssList != undefined && this.dss.suggAssList.length > 0) {
            this.suggAssList = this.dss.suggAssList;
            if (this.dss.selected_suggAssList.length > 0) {
              this.showColor = true;
            }
          } else {
            this.getSuggestedAssociation();
          }
        }
      });
    }));
  }

  /**
   * get Suggested Association
   */
  getSuggestedAssociation(): void {
    this.subscriptions.add(this.getApiSer.getsuggestedAssociation(this.user_country[0].id).subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        if (data.status == 1) {
          this.suggAssList = data.data.association_list;
          this.dss.suggAssList = this.suggAssList;
          if (this.dss.selected_suggAssList.length == 0) {
            // tslint:disable-next-line: radix
            this.dss.selected_suggAssList = this.dss.suggAssList.filter(obj => parseInt(obj.is_member) == 1);
            if (this.dss.selected_suggAssList.length > 0) {
              this.showColor = true;
            }
          }

        } else {
          this.fcs.errorHandeler(data);
        }
      });
    }));
  }

  /**
   * reset DDL Data
   */
  resetDDLData(data): void {
    if (data.item.length > 0) {
      this.dss.selected_suggAssList = [];
      this.onboardingService.ddl_data.selected_data = [];
      this.user_country = [];
      this.onboardingService.ddl_data.selected_data.push(data.item[0]);
      this.user_country.push(data.item[0]);
      this.err_msg = '';
      this.getSuggestedAssociation();
      this.err_msg = '';
    }
  }

  /**
   * select Value
   */
  selectValue(e, data): void {
    this.err_msg = '';
    if (e.target.checked == true) {

      if (this.dss.selected_suggAssList.length >= 4) {
        e.target.checked = false;
        this.err_msg = this.mls.languageText.verification_country_and_association_screen.key5;
        return;
      }

      if (this.dss.selected_suggAssList.length < 3) {
        this.dss.selected_suggAssList.push(data);
      } else if (this.dss.selected_suggAssList.length < 4 && data.is_public == 1) {
        this.dss.selected_suggAssList.push(data);
      } else if (this.dss.selected_suggAssList.length < 4 && data.is_public == 0) {
        const temp = this.dss.selected_suggAssList.filter(x => x.is_public === '1' || x.is_public == 1);

        if (temp.length > 0) {
          this.dss.selected_suggAssList.push(data);
        } else {
          e.target.checked = false;
          this.err_msg = this.mls.languageText.verification_country_and_association_screen.key5;
          return;
        }
      }
    } else {
      let i = 0;
      for (; i < this.dss.selected_suggAssList.length; i++) {
        if (this.dss.selected_suggAssList[i].association_id == e.target.value) {
          break;
        }
      }
      this.dss.selected_suggAssList.splice(i, 1);
    }
    this.showColor = (this.dss.selected_suggAssList.length > 0 && this.user_country.length > 0) ? true : false;
  }

  /**
   * assign Association
   */
  assignAssociation(): void {
    const y = [];
    this.dss.selected_suggAssList.map(x => y.push(x.association_id));
    this.subscriptions.add(this.postApiSer.assignAssociation('association', '[' + y + ']', '', 0).subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {

        if (data['status'] == 1) {
          if (data['code'] == 2000) {
            this.displayObj.isShow = true;
            this.displayObj.display_section = 'verificationSuccess';
            this.displayObj.data = data['data'];
            this.displayObj.errObj = [];
            this.masterSer.showWebModal.next(this.displayObj);
          }
        } else {
          this.fcs.errorHandeler(data);
          return;
        }
      });
    }));
  }

  /**
   * make Selected
   */
  makeSelected(id): boolean {
    if (this.dss.selected_suggAssList != undefined) {
      const x = this.dss.selected_suggAssList.filter(x => x.association_id == id);
      if (x.length > 0) {
        return true;
      }
    }
  }

  /**
   * go Back
   */
  goBack(): void {
    const displayObj = {
      isShow: false,
      display_section: '',
      data: []
    };
    this.masterSer.showWebModal.next(displayObj);
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
